const photoUpload = (files = null) => {

    const data = new FormData();
    data.append('login', localStorage.getItem('login'));
    data.append('password', localStorage.getItem('password'));
    let ins = files.length;
    for (let x = 0; x < ins; x++) {
        data.append("photos[]", files[x]);
    }

    let headers = new Headers()

    return fetch('/covers_upload.php', { method: 'POST', headers: headers, body: data })
        .then(response => {
            if ( response.status >= 400 ) {
                throw new Error('Ошибка сервера: '+ response.status)
            }
            return response.json()
        })
        .then(json => {
            return json
        })
        .catch(e => {
            throw e
        })
}

export default photoUpload


// WEBPACK FOOTER //
// ./src/utils/photoUpload.js